import * as React from 'react';
import Overlay from 'automaailm-ui/lib/Components/Overlay/index';
import { Trans, useTranslation } from 'react-i18next';
import useOverlays from '../../../components/overlay/Overlay';

interface IProps {
    timeRemaining: number;
}

const ClosingTime = (props: IProps) => {
    const { t } = useTranslation();
    const { overlays, closeOverlay } = useOverlays();
    const { timeRemaining } = props;

    return (
        <React.Fragment>
            <Overlay
                isOpen={overlays.indexOf('closing') !== -1}
                layout="dialog"
                doClose={(e) => {
                    e.preventDefault();
                }}
                dialogConfig={{
                    description: (
                        <React.Fragment>
                            <Trans i18nKey="checkout.storeClose" values={{ time: timeRemaining }}>
                                <b>5 minutes</b>
                            </Trans>
                            <br />
                            {t('Please hurry to checkout')}
                        </React.Fragment>
                    ),
                    buttons: [
                        {
                            title: t('checkout.Understood'),
                            intent: 'primary',
                            onClick: () => {
                                closeOverlay('closing');
                            },
                        },
                        {
                            title: t('checkout.Close'),
                            intent: 'primary',
                            layout: 'link',
                            onClick: () => {
                                closeOverlay('closing');
                            },
                        },
                    ],
                }}
            />
        </React.Fragment>
    );
};
export default ClosingTime;
